export default __webpack_public_path__ + "static/media/014-mussel.bd70ffde.svg";